module.exports = __webpack_public_path__ + "static/Feedbacks-2892755747ed3deb89886228323d2e73.svg";